<template>
    <div id="shopping-cart">
        <CartToast/>
        <div class="cart-container" :class="{active: getShowCart}">
            <Cart/>
            <Checkout/>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import CartToast from './cartComponents/CartToast';
    import Cart from './cartComponents/Cart';
    import Checkout from './cartComponents/Checkout';

    export default {
        name: "ShoppingCart",
        components: {
            CartToast,
            Cart,
            Checkout
        },
        computed: {
            ...mapGetters(['getShowCart'])
        },
        methods: {
            ...mapActions(['fetchSettings'])
        },
        created() {
            this.fetchSettings();
        }
    }
</script>
